import React, {useState, useEffect} from "react";
import ReviewCard from "../../components/reviewCard";

import ier_logo from "../../assets/images/icons/ier-logo2.png";
import moment from "moment";
import apply_icon from "../../assets/images/icons/apply-icon.png";
import { useHistory } from "react-router-dom";
import download_icon from "../../assets/images/icons/download-icon.png";
import LoadingSpinner from "../../components/loadingSpiner";
import { useDispatch, useSelector } from "react-redux";
import {
  generateMembershipCertificate,
} from "../../actions";

const FirmDetails = ({
  applicationDetails,
  application,
  actionLoader,
  generateCertificate,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [download, setDownload] = useState(false);
  const [hasDownloaded, setHasDownloaded] = useState(false);

  const apiResponse = useSelector((state) => {
    const {
      fetchFile,
    } = state;
    const { file } = fetchFile;

    return {
      file,
    };
  });

  useEffect(() => {
    if (apiResponse.file?.fileText != null && !hasDownloaded && download) {
      var a = document.createElement("a");
      a.href =
        "data:image/" +
        apiResponse.file?.type +
        ";base64," +
        apiResponse.file?.fileText;
      a.download =
        apiResponse.file?.name || "File" + "." + apiResponse.file?.type || "";
      a.click();
      setHasDownloaded(true);
    }
  }, [apiResponse.file]);

  const handleFileDownload = (fileText, type) => {
    if (actionLoader) {
      return;
    }
    let url;
    if (fileText !== "" && fileText !== undefined) {
      url = encodeURIComponent(
        fileText.substring(fileText.indexOf("/tmp"), fileText.length)
      );
      dispatch(generateMembershipCertificate(url));
    }
    setDownload(true);
    setHasDownloaded(false);
  };



  return (
    <div className="membership_wrapper">
      <div className="toolbar">
        <div className="toolbar-title">
          <h2>Membership</h2>
        </div>
        {application?.status === "Approved by ES" ? (
          <div
            className="apply-btn"
            style={{
              padding: "10px 25px",
              backgroundColor: actionLoader ? "#ccc" : "",
            }}
            onClick={() =>
              generateCertificate(applicationDetails.certficateFile?.fileText)
            }
          >
            <img src={apply_icon} alt="file" />
            <span>Download Certificate</span>
          </div>
        ) : null}

        {application?.status === "Unpaid invoice(s)" && (
          <div
            className="apply-btn"
            style={{ backgroundColor: "#E01E5A" }}
            onClick={() =>
              history.push({
                pathname: "/applicant/payment-details",
                state: {
                  application: applicationDetails,
                  isMembership: 3,
                  headerSection: true,
                },
              })
            }
          >
            <img src={apply_icon} alt="file" />
            <span>Pay for Membership</span>
          </div>
        )}
      </div>
      <div className="application-status-sub-header mt-4">
        <div className="content">
          <span className="title" style={{ textAlign: "center", fontSize: 14 }}>
            Membership Registration No:
          </span>
          <span className="title-content" style={{ textAlign: "center" }}>
            {application?.registrationNumber || '-'}
          </span>
        </div>
        <div className="content">
          <span className="title" style={{ textAlign: "center", fontSize: 14 }}>
            Approval Date:
          </span>
          <span className="title-content" style={{ textAlign: "center" }}>
            {moment(application?.approvalDate).format("MMMM Do YYYY")}
          </span>
        </div>
        <div className="content">
          <span className="title" style={{ textAlign: "center", fontSize: 14 }}>
            Membership Class:
          </span>
          <span className="title-content" style={{ textAlign: "center" }}>
            {application?.membershipClass?.name}
          </span>
        </div>
        <div className="content">
          <span className="title" style={{ textAlign: "center", fontSize: 14 }}>
            Membership Discipline
          </span>
          <span className="title-content" style={{ textAlign: "center" }}>
            {application?.discipline?.name || '-'}
          </span>
        </div>
        <div className="content">
          <span className="title" style={{ textAlign: "center", fontSize: 14 }}>
            Membership Application Status:
          </span>
          <span className="title-content" style={{ textAlign: "center" }}>
            {application?.clientStatus?.toLowerCase()}
          </span>
        </div>
        {/* <div className="content">
                  <span className="title" style={{textAlign: 'center', fontSize: 14}}>Registration Date:</span>
                  <span className="title-content" style={{textAlign: 'center'}}>{application?.status?.toLowerCase() === 'compliant' ? 'Compliant' : 'Non compliant'}</span>
              </div> */}
      </div>
      {application ? (
        <div className="dashboard-review-container mt-4">
          <div className="dashboard-review-title-container">
            <div
              style={{
                width: "10%",
              }}
            >
              <img src={ier_logo} />
            </div>
            <div
              style={{
                width: "70%",
              }}
            >
              <span className="review-header-title-text">
                INSTITUTION OF ENGINEERS RWANDA
              </span>
              <br />
              <span className="review-sub-title">
                Kimihurura - KG 666st Kigali-Rwanda <br />
                P.o.Box 4386 Kigali Rwanda <br />
                Telephone:
                <span
                  style={{
                    fontWeight: "bold",
                    marginLeft: 2,
                  }}
                >
                  (+250) 789 904 228
                </span>
                - Email:
                <span
                  style={{
                    fontWeight: "bold",
                    marginLeft: 2,
                  }}
                >
                  info@engineersrwanda.rw
                </span>
                - website:
                <span
                  style={{
                    fontWeight: "bold",
                    marginLeft: 2,
                  }}
                >
                  https://www.engineersrwanda.rw
                </span>
              </span>
            </div>
          </div>
          <div>
            <ReviewCard
              title="Company details"
              path="/applicant/company/details"
              state={applicationDetails}
              isMember={true}
              hasEdit={true}
            >
              <div
                className="review-details-content-conatiner"
                style={{ justifyContent: "space-between" }}
              >
                <div className="review-details-profile-icon">
                  {applicationDetails.portraitPhotoFile && (
                    <img
                      src={`data:image/${applicationDetails.portraitPhotoFile?.type};base64,${applicationDetails.portraitPhotoFile?.fileText}`}
                      style={{ width: "100%", height: "80%" }}
                    />
                  )}
                </div>
                <div className="review-details-profile-container">
                  <div>
                    <div>
                      <span>Company names</span>
                      <p>{applicationDetails.companyNames}</p>
                    </div>
                    <div>
                      <span>Company activities</span>
                      <p>{applicationDetails.companyActivities}</p>
                    </div>
                  </div>
                </div>

                <div className="review-details-gender-details">
                  <div>
                    <span>Date of business registration</span>
                    <p>
                      {moment(applicationDetails.registrationDate).format(
                        "MMMM Do YYYY, h:mm:ss a"
                      )}
                    </p>
                  </div>
                  <div>
                    <span>Business Certificate number</span>
                    <p>{applicationDetails.businessCertificateNumber}</p>
                  </div>
                </div>
              </div>
            </ReviewCard>

            <ReviewCard
              title="Contact details"
              path="/applicant/company/contacts"
              state={applicationDetails}
              isMember={true}
              hasEdit={true}
            >
              <div className="review-details-content-conatiner">
                <div className="review-details-contact-container-first">
                  <div className="d-flex">
                    <div className="contancts-container">
                      <div>
                        <span>Phone number</span>
                        <p>{applicationDetails.contactTelephoneNumber}</p>
                      </div>
                    </div>
                    <div className="">
                      <div>
                        <span>Email address</span>
                        <p>{applicationDetails.contactEmail}</p>
                      </div>
                    </div>
                  </div>
                  <div className="seperator-contact"></div>
                  <div className="d-flex">
                    <div className="contancts-container">
                      <div>
                        <span>Secondary Phone number</span>
                        <p>
                          {applicationDetails.secondaryContactTelephoneNumber}
                        </p>
                      </div>
                    </div>
                    <div className="">
                      <div>
                        <span>Main Email address</span>
                        <p>{applicationDetails.secondaryContactEmail}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="review-details-contact-container-second">
                  <div className="">
                    <div>
                      <span>Residence Address</span>
                      {applicationDetails.residenceType === "Local" ? (
                        <p>
                          {applicationDetails.provinceId?.name},
                          {applicationDetails.districtId?.name},
                          {applicationDetails.sectorId?.name},
                          {applicationDetails.cellId?.name},
                          {applicationDetails.villageId?.name},
                          {applicationDetails.streetOrHouseNumber}
                        </p>
                      ) : (
                        <p>
                          {applicationDetails.countryOfResidence?.name},{" "}
                          {applicationDetails.residenceAddress}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </ReviewCard>
            <ReviewCard
              title="Company Directors/ Shareholders"
              path="/applicant/company/shareholders"
              state={applicationDetails}
              isMember={true}
              hasEdit={true}
            >
              <div className="review-details-content-conatiner">
                <div
                  className="review-details-contact-container-first"
                  style={{ width: "100%" }}
                >
                  {applicationDetails.stakeholders?.length > 0 &&
                    applicationDetails.stakeholders?.map((value) => {
                      return (
                        <>
                          <div
                            className="d-flex"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div>
                              <div>
                                <span>Full names</span>
                                <p>{value.fullName}</p>
                              </div>
                            </div>
                            <div className="">
                              <div>
                                <span>Phone</span>
                                <p>{value.telephoneNumber}</p>
                              </div>
                            </div>
                            <div>
                              <span>National ID number</span>
                              <p>{value.nationalIdNumber}</p>
                            </div>
                            <div>
                              <span>IER number</span>
                              <p>{value.ierMemberNumber}</p>
                            </div>
                          </div>
                          <div
                            className="seperator-contact"
                            style={{ width: "100%" }}
                          ></div>
                        </>
                      );
                    })}
                </div>
              </div>
            </ReviewCard>
            <ReviewCard
              title="Projects accomplished details"
              path="/applicant/company/projects"
              state={applicationDetails}
              isMember={true}
              hasEdit={true}
            >
              <div className="review-details-content-conatiner">
                <div
                  className="review-details-contact-container-first"
                  style={{ width: "100%" }}
                >
                  {applicationDetails.projects?.length > 0 &&
                    applicationDetails.projects.map((value) => {
                      return (
                        <>
                          <div
                            className="d-flex"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div>
                              <div>
                                <span>Name of the project</span>
                                <p>{value.name}</p>
                              </div>
                            </div>
                            <div className="">
                              <div>
                                <span>Client</span>
                                <p>{value.client}</p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seperator-contact"
                            style={{ width: "100%" }}
                          ></div>
                        </>
                      );
                    })}
                </div>
              </div>
            </ReviewCard>

            <ReviewCard
              title="Attachments"
              path="/applicant/company/attachments"
              state={applicationDetails}
              hasEdit={true}
              isMember={true}
            >
              <div className="review-details-content-conatiner">
                <div
                  className="review-details-contact-container-first"
                  style={{ width: "100%" }}
                >
                  <div
                    className="d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    {applicationDetails.cv && (
                      <div>
                        <span> Managing or technical director's resume</span>
                        {/* <img src={`data:image/${applicationDetails.cv?.type};base64,${applicationDetails.cv?.fileText}`} style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {applicationDetails.cv?.name}
                        </p>
                        <span
                          onClick={() =>
                            handleFileDownload(applicationDetails.cv?.fileText, applicationDetails.cv?.type)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          download
                        </span>
                      </div>
                    )}

                    {applicationDetails.businessCertificateDocumentFile && (
                      <div>
                        <span> certified Business certificate</span>
                        {/* <img src={`data:image/${applicationDetails.businessCertificateDocumentFile?.type};base64,${applicationDetails.businessCertificateDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {
                            applicationDetails.businessCertificateDocumentFile
                              ?.name
                          }
                        </p>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleFileDownload(
                              applicationDetails.businessCertificateDocumentFile
                                ?.fileText,
                                applicationDetails.businessCertificateDocumentFile
                                ?.type
                            )
                          }
                        >
                          download
                        </span>
                      </div>
                    )}

                    {/* { applicationDetails.rdbRegistrationDocumentFile &&  <div>
                                                <span> RDB Registration Certificate</span>
                                                <p style={{marginBottom: '0px'}}>{applicationDetails.rdbRegistrationDocumentFile?.name}</p>
                                                <span 
                                                    onClick={()=>handleFileDownload(applicationDetails.rdbRegistrationDocumentFile?.fileText)}
                                                    style={{cursor: 'pointer'}}>download</span>
                                            </div> 
                                        } */}
                  </div>
                  <div
                    className="seperator-contact"
                    style={{ width: "100%" }}
                  ></div>
                  <div
                    className="d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    {applicationDetails.practicingLicenseDocumentFile && (
                      <div>
                        <span>
                          {" "}
                          Managing/Technical Director’s Practicing License
                        </span>
                        {/* <img src={`data:image/${applicationDetails.practicingLicenseDocumentFile?.type};base64,${applicationDetails.practicingLicenseDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {
                            applicationDetails.practicingLicenseDocumentFile
                              ?.name
                          }
                        </p>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleFileDownload(
                              applicationDetails.practicingLicenseDocumentFile
                                ?.fileText,
                                applicationDetails.practicingLicenseDocumentFile
                                ?.type
                            )
                          }
                        >
                          download
                        </span>
                      </div>
                    )}

                    {applicationDetails.companyProfileDocumentFile && (
                      <div>
                        <span> Company Profile</span>
                        {/* <img src={`data:image/${applicationDetails.companyProfileDocumentFile?.type};base64,${applicationDetails.companyProfileDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {applicationDetails.companyProfileDocumentFile?.name}
                        </p>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleFileDownload(
                              applicationDetails.companyProfileDocumentFile
                                ?.fileText,
                                applicationDetails.companyProfileDocumentFile
                                ?.type
                            )
                          }
                        >
                          download
                        </span>
                      </div>
                    )}

                    {applicationDetails.rssbCertificateDocumentFile && (
                      <div>
                        <span> RSSB Certificate</span>
                        {/* <img src={`data:image/${applicationDetails.rssbCertificateDocumentFile?.type};base64,${applicationDetails.rssbCertificateDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {applicationDetails.rssbCertificateDocumentFile?.name}
                        </p>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleFileDownload(
                              applicationDetails.rssbCertificateDocumentFile
                                ?.fileText,
                                applicationDetails.rssbCertificateDocumentFile
                                ?.type
                            )
                          }
                        >
                          download
                        </span>
                      </div>
                    )}
                  </div>
                  <div
                    className="seperator-contact"
                    style={{ width: "100%" }}
                  ></div>
                  <div
                    className="d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    {applicationDetails.taxClearanceDocumentFile && (
                      <div>
                        <span> RRA Tax Clearance Certificate</span>
                        {/* <img src={`data:image/${applicationDetails.taxClearanceDocumentFile?.type};base64,${applicationDetails.taxClearanceDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                        <p style={{ marginBottom: "0px" }}>
                          {applicationDetails.taxClearanceDocumentFile?.name}
                        </p>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleFileDownload(
                              applicationDetails.taxClearanceDocumentFile
                                ?.fileText,
                                applicationDetails.taxClearanceDocumentFile
                                ?.type
                            )
                          }
                        >
                          download
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </ReviewCard>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "10%",
          }}
        >
          <LoadingSpinner color={"#1D834F"} />
        </div>
      )}
    </div>
  );
};

export default FirmDetails;
